import { showAlert } from "@erp/shared/utils/dialog";
import { uploadFileToS3 } from "@erp/shared/api/generated/wrappers/s3";
/**
 * @description 파일을 S3에 업로드하고, 성공 시 업로드된 파일 이름(원래 파일 이름, 업로드된 파일 이름)을 반환함.
 * 실패한 파일이 있다면 실패한 파일 이름을 반환함.
 * @param {UploadTask[]} uploadTasks - 업로드할 파일 정보 객체
 */
export const uploadFilesWithMapping = async (uploadTasks) => {
    // 모든 파일 업로드
    const uploadResults = await Promise.allSettled(uploadTasks.map(async ({ category, file, path }) => {
        if (Array.isArray(file)) {
            const originalNames = file.map((f) => f.name);
            const s3FileNames = await Promise.all(file.map(async (f) => uploadFileToS3(f, path)));
            return {
                category,
                originalName: originalNames,
                s3FileName: s3FileNames,
            };
        }
        else {
            const s3FileName = await uploadFileToS3(file, path);
            return {
                category,
                originalName: file.name,
                s3FileName: s3FileName,
            };
        }
    }));
    const successfulFiles = {};
    const failedFiles = [];
    uploadResults.forEach((result) => {
        if (result.status === "fulfilled") {
            const { category, originalName, s3FileName } = result.value;
            successfulFiles[category] = {
                originalName,
                s3FileName,
            };
        }
        else {
            failedFiles.push(result.reason instanceof Error
                ? result.reason.message
                : String(result.reason));
        }
    });
    return { successfulFiles, failedFiles };
};
export const alertSuccessFiles = (successfulFiles) => {
    const names = [];
    Object.values(successfulFiles).forEach((info) => {
        if (Array.isArray(info.originalName)) {
            names.push(...info.originalName);
        }
        else {
            names.push(info.originalName);
        }
    });
    if (names.length > 0) {
        showAlert(`성공한 파일: ${names.join(", ")}`, "파일 업로드 성공");
    }
};
export const alertFailedFiles = (failedFiles) => {
    if (failedFiles.length > 0) {
        showAlert(`실패한 파일: ${failedFiles.join(", ")}`, "일부 파일 업로드 실패");
    }
};
